var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* istanbul ignore file */
import { StrictMode, Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "@here/hds-base/build/hds-styles.css";
import "@here/hds-iconlibrary/build/hds-iconlibrary-8px.css";
import "@here/hds-iconlibrary/build/hds-iconlibrary-16px.css";
import "@here/hds-iconlibrary/build/hds-iconlibrary-24px.css";
import "@here/hds-grid/build/hds-grid.css";
import { BrowserRouter as Router } from "react-router-dom";
import Loader from "./components/loader";
import store from "./store/store";
import * as serviceWorker from "./serviceWorker";
import App from "./app/App";
import "./index.scss";
import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
var render = function () {
    ReactDOM.render(_jsx(StrictMode, { children: _jsx("div", __assign({ "data-theme": "hds-web-product-light-theme", "data-styles": "hds" }, { children: _jsx("hds-modal-container", __assign({ id: "modal-container" }, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(ErrorBoundary, { children: _jsx(Suspense, __assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(Router, __assign({ basename: process.env.NODE_ENV === "development" ? "/" : "/indoor" }, { children: _jsx(App, {}) })) })) }) })) })) })) }), document.getElementById("root"));
};
render();
if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./app/App", render);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
